import { useCallback, useEffect, useMemo, useState } from 'react';
import { IVehiclesCapacities, vehicle_types } from '@helpers/types.ts';
import { Route } from '@helpers/types.ts';

export const useSplitRoute = (route: Route) => {
  const [vehicles, setVehicles] = useState<Partial<IVehiclesCapacities>>({
    [vehicle_types.motorcycle]: 0,
    [vehicle_types.auto]: 0,
    [vehicle_types.small_van]: 0,
    [vehicle_types.large_van]: 0,
  });
  const [error, setError] = useState<string | null>('');
  const [loading, setLoading] = useState<boolean>(false);

  const totalVehicles = useMemo(() => {
    return Object.values(vehicles).reduce((acc, value) => acc + value, 0);
  }, [vehicles]);

  const onChangeVehicles = useCallback((vehicles: Partial<IVehiclesCapacities>) => {
    setVehicles(vehicles);
  }, []);

  useEffect(() => {
    const max_total = parseInt(String(Math.round(route.orders.length / 60)));
    if (totalVehicles > max_total) {
      setError(`El número máximo de vehículos es ${max_total}`);
    } else if (totalVehicles <= 1) {
      setError('El número mínimo de vehículos es 2');
    } else setError(null);
  }, [totalVehicles]);

  return {
    error,
    loading,
    vehicles,
    setLoading,
    totalVehicles,
    onChangeVehicles,
  };
};
